module.exports = __webpack_public_path__ + "img/10_5.4a3ad4f1.png";